import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VueI18n from 'vue-i18n';

import {
	VAutocomplete,
	VCard,
	VDataFooter,
	VDataTable,
	VDataTableHeader,
	VDivider,
	VInput,
	VLabel,
	VMessages,
	VProgressLinear,
	VSelect,
	VSimpleCheckbox,
	VSimpleTable,
	VTextField
  } from 'vuetify/lib';

Vue.use(VueI18n,  {
	components: {
		VAutocomplete,
		VCard,
		VDataFooter,
		VDataTable,
		VDataTableHeader,
		VDivider,
		VInput,
		VLabel,
		VMessages,
		VProgressLinear,
		VSelect,
		VSimpleCheckbox,
		VSimpleTable,
		VTextField
	}
  });

const dateTimeFormats = {
	'en': {
		short: {
			year: 'numeric', month: 'short', day: 'numeric'
		},
		long: {
			year: 'numeric', month: 'short', day: 'numeric',
			weekday: 'short', hour: 'numeric', minute: 'numeric'
		}
	}
};
//https://stackoverflow.com/questions/64252325/conflict-order-when-compiling-vue-project
const i18n = new VueI18n({
	locale: 'fr',
	fallbackLocale: 'en',
	messages: {},
	dateTimeFormats
});

Vue.use(Vuetify);

const vuetify = new Vuetify({
	iconfont: 'fa'
});

export {
	i18n,
	vuetify
};
